<template>
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            :search="search">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Purchase Order</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details />
                    <v-spacer />
                </v-toolbar>
            </template>
            <template v-slot:[`item.delivery`]="{ item }">
                {{ getScheduleDays(item.delivery_schedules) }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="viewPO(item)">
                    mdi-eye
                </v-icon>
                <v-icon small class="mr-2" @click="editPO(item)" v-if="$store.state.currentPagePriv.update">
                    mdi-pencil
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">
                    Reset
                </v-btn>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    data: () => ({
        headers: [
            { text: 'Outlet', value: 'name' },
            { text: 'Delivery Schedule', value: 'delivery', sortable: false },
            { text: 'Actions', value: 'actions', sortable: false },
        ],
        items: [],
        search: '',
    }),

    created() {
        this.initialize()
    },

    computed: {
        defaultDays() {
            return this.$store.state.outlet.default_days;
        },
    },

    methods: {
        async initialize() {
            let response = await this.$store.dispatch('outlet/getObjs')
            if (response.data.status == 'success') {
                this.items = response.data.data
            }
        },
        getScheduleDays(data) {
            return this.defaultDays
                .filter(schedule => data.includes(schedule.key))
                .map(schedule => schedule.value)
                .join(', ')
        },
        async editPO(item) {
            this.$router.push(`/po/form/${item.code}`)
        },
        async viewPO(item) {
            this.$router.push(`/po/view/${item.code}`)
        }
    }
}
</script>